import _typeof from "@babel/runtime/helpers/esm/typeof";
import _extends from "@babel/runtime/helpers/esm/extends";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
var _CenterBox, _Divider;
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import React, { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { CenterBox } from '@im/ui-lib/CenterBox';
import CircularProgress from '@mui/material/CircularProgress';
import Divider from '@mui/material/Divider';
import Link from '@mui/material/Link';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Stack from '@mui/material/Stack';
import { useTranslate } from '@im/react-localization';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function SideNavMenu(props) {
  var _props$dataTestid = props['data-testid'],
    testid = _props$dataTestid === void 0 ? 'required' : _props$dataTestid,
    _props$isPrimary = props.isPrimary,
    isPrimary = _props$isPrimary === void 0 ? false : _props$isPrimary,
    level = props.level,
    navItem = props.navItem,
    onNavItemClick = props.onNavItemClick,
    onNavItemHover = props.onNavItemHover;
  var translate = useTranslate();
  var navItems = navItem.navItems;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    itemArr = _useState4[0],
    setItemArr = _useState4[1];
  var itemsToMap = Array.isArray(navItems) ? navItems : itemArr;
  var PRODUCTS = 'products';
  var VENDORS = 'vendors';
  var viewAllMap = [PRODUCTS, VENDORS];
  var getViewAllLinkByKey = function getViewAllLinkByKey(key) {
    if (key === PRODUCTS) {
      return 'product/productsearch';
    } else if (key === VENDORS) {
      return '/cms/vendorsList';
    }
  };
  useEffect(function () {
    var active = true;
    if (Array.isArray(navItems)) {
      return;
    } else if (typeof navItems === 'function') {
      _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var arr;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              setLoading(true);
              _context.next = 3;
              return navItems();
            case 3:
              arr = _context.sent;
              if (active) {
                setItemArr(arr);
                setLoading(false);
              }
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
    return function () {
      active = false;
    };
  }, [navItems]);
  return /*#__PURE__*/_jsxs(RootStack, {
    "data-element": "RootStack",
    "data-component": "SideNavMenu",
    "data-source-file": "SideNavMenu.tsx",
    children: [loading && (_CenterBox || (_CenterBox = /*#__PURE__*/_jsx(CenterBox, {
      children: /*#__PURE__*/_jsx(CircularProgress, {})
    }))), /*#__PURE__*/_jsxs(MenuList, {
      sx: _extends({
        maxHeight: "calc(100% - 135px)"
      }, navItem.key === VENDORS && {
        padding: '16px 8px 33px 8px !important'
      }),
      "data-element": "MenuList",
      "data-source-file": "SideNavMenu.tsx",
      children: [navItem.key === VENDORS && /*#__PURE__*/_jsx(StyledMenuItemTitle, {
        dense: true,
        style: {
          cursor: 'auto'
        },
        children: /*#__PURE__*/_jsx(ListItemText, {
          children: translate('Dashboard.MyTopVendors')
        })
      }, "Featured Vendors"), /*#__PURE__*/_jsx(ScrollArea, {
        style: {
          maxHeight: '100%',
          overflowY: 'scroll'
        },
        "data-element": "ScrollArea",
        "data-source-file": "SideNavMenu.tsx",
        children: itemsToMap.map(function (item) {
          var hasItems = Boolean(item.navItems);
          var cursor = item.route || item.url || item.onClick ? 'pointer' : 'auto';
          return /*#__PURE__*/_jsxs(StyledMenuItem, {
            "data-testid": "".concat(testid, "-").concat(item.key, "-CategoryName"),
            dense: true,
            disableGutters: true,
            onMouseEnter: function onMouseEnter(e) {
              onNavItemHover(item, level);
            },
            style: {
              cursor: "".concat(cursor)
            },
            children: [/*#__PURE__*/_jsx(ListItemText, {
              onClick: item.route || item.url || item.onClick ? function () {
                return onNavItemClick(item, level);
              } : undefined,
              children: item.label || item.key
            }), hasItems && /*#__PURE__*/_jsx(ListItemIcon, {
              onClick: function onClick(e) {
                onNavItemHover(item, level);
              },
              children: /*#__PURE__*/_jsx(ArrowForwardIosIcon, {
                sx: {
                  height: '12px',
                  minWidth: 'inherit',
                  width: '12px'
                }
              })
            })]
          }, item.key);
        })
      })]
    }), viewAllMap.includes(navItem.key) && /*#__PURE__*/_jsxs(StyledStack, {
      isMaxReached: itemsToMap.length > 19,
      isPrimary: isPrimary,
      children: [_Divider || (_Divider = /*#__PURE__*/_jsx(Divider, {})), /*#__PURE__*/_jsx(Link, {
        onClick: function onClick() {
          return onNavItemClick({
            key: 'ViewAll',
            route: getViewAllLinkByKey(navItem.key)
          }, level);
        },
        variant: "link",
        children: translate('ProductSearchResources.ViewAll')
      })]
    })]
  });
}
var RootStack = styled(Stack)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    borderRadius: 0,
    borderRight: "1px solid ".concat(theme.palette.divider),
    height: '100%',
    width: '240px'
  };
});
var ScrollArea = styled('div')(function (_ref3) {
  var theme = _ref3.theme;
  return {
    '&::-webkit-scrollbar': {
      width: '6px'
    },
    '&::-webkit-scrollbar-thumb': {
      background: theme.palette.grey[300],
      borderRadius: '1px'
    },
    '&::-webkit-scrollbar-track': {
      borderRadius: '1px',
      boxShadow: 'none'
    },
    flexGrow: 1,
    overflowX: 'hidden',
    overflowY: 'auto'
  };
});
var StyledMenuItem = styled(MenuItem)(function (_ref4) {
  var theme = _ref4.theme;
  return {
    '& .MuiListItemIcon-root': {
      height: 12,
      minWidth: 'inherit',
      width: 12
    },
    '&:hover': {
      backgroundColor: theme.palette.grey[50],
      color: theme.palette.primary.dark
    },
    '.MuiListItemText-primary': {
      cursor: 'pointer',
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '22px',
      whiteSpace: 'break-spaces'
    },
    marginLeft: 16,
    padding: 8,
    width: '92%'
  };
});
var StyledStack = styled(Stack, {
  shouldForwardProp: function shouldForwardProp(props) {
    return props !== 'isPrimary';
  }
})(function (_ref5) {
  var isMaxReached = _ref5.isMaxReached,
    isPrimary = _ref5.isPrimary,
    theme = _ref5.theme;
  return {
    '& .MuiDivider-root': {
      borderColor: theme.palette.grey[300]
    },
    '& .MuiTypography-root': {
      color: '#0164B0',
      fontWeight: 400,
      marginLeft: '8px',
      padding: '8px 4px 4px 4px'
    },
    backgroundColor: 'transparent',
    bottom: isMaxReached ? '68px' : 0,
    padding: isPrimary ? '0 8px' : '0 8px 0 20px',
    position: isMaxReached ? 'absolute' : 'relative',
    width: '100%'
  };
});
var StyledMenuItemTitle = styled(MenuItem)(function (_ref6) {
  var theme = _ref6.theme;
  return {
    '&:hover': {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.common.black
    },
    '.MuiListItemText-primary': {
      fontSize: '14px',
      fontWeight: 600,
      lineHeight: '22px'
    },
    marginLeft: 16,
    padding: 4,
    width: 188
  };
});